import React from "react";
import { PartialNullable } from "../../../types";
import { DraftAlbum, TrackReleaseSet } from "../../../api/useMusicApi";
import { UpdateFields } from "../../../hooks/use-advanced-state";
import cn from "classnames";
import { useTranslation } from "../../../hooks/useTranslation";
import {
  ValidationError,
  ValidationInputWrapper,
} from "../../../components/ValidationInputWrapper";
import { CopyFieldValueButton } from "../../../components/CopyFieldValueButton";
import { isAlbum } from "./DraftFormTitlePart";
import { LabelHint } from "../../../components/LabelHint";
import { DraftFormArtist } from "./DraftFormArtist";

export enum ArtistType {
  MAIN = "main",
  FEATURED = "featured",
}

type Props = {
  type: ArtistType;
  disabled?: boolean;
  draft: PartialNullable<DraftAlbum | TrackReleaseSet>;
  onChange: UpdateFields<DraftAlbum | TrackReleaseSet>;
  className?: string;
  validationErrorPrefix?: string;
  validationErrors?: ValidationError[];
  onChangeForAll?: (field: keyof TrackReleaseSet | string, value?: any) => void;
};
export const DraftFormArtistPart: React.FC<Props> = ({
  type,
  validationErrors = [],
  validationErrorPrefix,
  draft,
  disabled,
  onChange,
  className,
  onChangeForAll,
}) => {
  const { t } = useTranslation();
  return (
    <div className={cn(className, "dark:bg-neutral-700")}>
      <div className={"font-bold text-sm mb-1"}>
        <span>
          {type === ArtistType.MAIN
            ? `${t("main_artists_title")}`
            : `${t("featured_artists_title")}`}
        </span>

        {type === ArtistType.MAIN && (
          <span className={"text-red-500 font-bold"}> *</span>
        )}
        {!disabled && (
          <>
            <CopyFieldValueButton
              visible={!isAlbum(draft ?? {}) && !(disabled ?? false)}
              fieldPath={`country_meta.artists.${
                type === ArtistType.MAIN ? "main" : "featured"
              }`}
              className={"ml-2"}
              onChangeForAll={onChangeForAll ?? null}
            />
            <LabelHint
              hint={t("artists_hint")}
              className={"inline-flex ml-2"}
            />
          </>
        )}
      </div>
      <ValidationInputWrapper
        attribute={`${
          validationErrorPrefix ? `${validationErrorPrefix}.` : ""
        }country_meta.artists.${type}`}
        validationErrors={validationErrors}
      >
        <DraftFormArtist
          type={type}
          draft={draft}
          onChange={onChange}
          disabled={disabled}
          validationErrors={validationErrors}
          validationErrorPrefix={validationErrorPrefix}
        />
      </ValidationInputWrapper>
    </div>
  );
};
